import React from 'react';
import { Checkbox, Input, Select, Button, Divider, Typography, Space } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

const { Option } = Select;
const { Text } = Typography;

const VersionList = ({
  platform,
  versions,
  csvList,
  serverList,
  pathList,
  handleVersionChange,
  handleRemoveVersion,
  color = '#1677ff',
  title = '',
}) => {
  return (
    <div style={{ background: '#fafdff', borderRadius: 8, padding: 16, marginBottom: 24 }}>
      <Text strong style={{ fontSize: 16, color }}>{title}</Text>
      <Divider style={{ margin: '8px 0 16px 0' }} />
      <Space direction="vertical" style={{ width: '100%', gap: 12 }}>
        {versions.map((v, idx) => (
          <div
            key={`${platform}-row-${idx}`}
            style={{
              background: '#f4f8ff',
              border: '1px solid #e0e7ef',
              borderRadius: 8,
              padding: 7,
              marginBottom: 0,
              display: 'flex',
              alignItems: 'center',
              gap: 3,
              transition: 'background 0.2s',
            }}
            onMouseOver={e => e.currentTarget.style.background = '#e6f0ff'}
            onMouseOut={e => e.currentTarget.style.background = '#f4f8ff'}
          >
            <Checkbox
              checked={v.isRecommendedUpdate}
              onChange={e => handleVersionChange(platform, idx, 'isRecommendedUpdate', e.target.checked)}
              style={{ width : 70 }}
            >
              권장
            </Checkbox>
            <Input
              placeholder="Build"
              value={v.version}
              onChange={e => handleVersionChange(platform, idx, 'version', e.target.value)}
              style={{ width: 100 }}
            />
            <Select
              value={v.csvVersion}
              onChange={value => handleVersionChange(platform, idx, 'csvVersion', value)}
              style={{ width: 150 }}
              showSearch
            >
              {csvList?.map(csv => (
                <Option key={csv} value={csv}>{csv}</Option>
              ))}
            </Select>
            {/* 서버/CSV 정보 시각적 구분 강화 */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, minWidth: 0, marginLeft: 16 }}>
              <span style={{ color: '#888', fontWeight: 500, minWidth: 30 }}>서버</span>
              <Select
                value={v.gameServer}
                onChange={value => handleVersionChange(platform, idx, 'gameServer', value)}
                style={{ width: 250 }}
              >
                {serverList.map((server, sidx) => (
                  <Option key={sidx} value={sidx}>{server}</Option>
                ))}
              </Select>
              <span style={{ color: '#888', fontWeight: 500, minWidth: 30 }}>CSV</span>
              <Select
                value={v.csvPath}
                onChange={value => handleVersionChange(platform, idx, 'csvPath', value)}
                style={{ width: 500 }}
              >
                {pathList.map((path, pidx) => (
                  <Option key={pidx} value={pidx}>{path}</Option>
                ))}
              </Select>
            </div>
            <Input
              placeholder="Memo"
              value={v?.memo || ''}
              onChange={e => handleVersionChange(platform, idx, 'memo', e.target.value)}
              style={{ width: 200 }}
              maxLength={200}
            />
            <div style={{ flex: 1 }} />
            <Button
              type="primary"
              danger
              size="small"
              icon={<DeleteOutlined />}
              onClick={() => handleRemoveVersion(platform, idx)}
              style={{ marginLeft: 3 }}
            >
              Remove
            </Button>
          </div>
        ))}
      </Space>
    </div>
  );
};

export default VersionList;

